import React from 'react';

interface BackgroundVideoProps {
  videoId: string;
  overlayOpacity?: number;
}

export const BackgroundVideo: React.FC<BackgroundVideoProps> = ({ 
  videoId, 
  overlayOpacity = 40
}) => {
  return (
    <>
      {/* Background Video Layer */}
      <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
        <iframe
          src={`https://customer-egd8wletnhjj8i2u.cloudflarestream.com/${videoId}/iframe?autoplay=true&loop=true&muted=true&preload=true&controls=false`}
          className="w-full h-full"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100vw',
            height: '56.25vw',
            minHeight: '100vh',
            minWidth: '177.78vh',
            border: 'none',
            pointerEvents: 'none',
          }}
          allow="autoplay; encrypted-media"
          title="Background video"
        />
      </div>
      
      {/* Overlay Layer */}
      <div 
        className="absolute inset-0 z-0 pointer-events-none"
        style={{ 
          backgroundColor: 'black',
          opacity: overlayOpacity / 100 
        }}
      />
    </>
  );
};

export default BackgroundVideo;
